<template>
    
    <div>
    <div id="agent-monitor">
            <v-dialog v-model="showDialog" max-width="460">
            <v-card>
            <v-card-title class="headline">{{ $t('agentMonitor.exportAgentActivity') }}</v-card-title>

            <v-card-text>
                <v-layout row wrap>
                    <v-flex xs6 class="px-1 mb-1">
                    {{ $t('agentMonitor.fromDate') }}
                </v-flex>

                <v-flex xs6 class="px-1 mb-1">
                    {{ $t('agentMonitor.toDate') }}
                </v-flex >
                <v-flex xs6 class="px-1">
                    <DatePickerOutline
                        flat
                        v-model="fromDate"
                        :max="toDate"
                        hide-details
                        append-icon="mdi-calendar"
                        prepend-inner-icon=""
                        @input="handleFromDateChange"
                        />
                </v-flex>

                <v-flex xs6 class="px-1">
                    <DatePickerOutline
                        flat
                        v-model="toDate"
                        :min="fromDate"
                        :max="toDay"
                        hide-details
                        append-icon="mdi-calendar"
                        prepend-inner-icon=""
                        @input="handleToDateChange"
                    />
                </v-flex >
                </v-layout>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn class="mb-2" text @click="showDialog = false">{{ $t('cancel') }}</v-btn>
                <v-btn class="mx-2 mb-2" color="primary" text @click="exportExcel">{{ $t('export') }}</v-btn>
            </v-card-actions>
            </v-card>
        </v-dialog>
    <div id="agent-monitor-header">
      <v-btn flat dark :to="`/bot/${activeBot.code}`" class="text-capitalize">
        <v-icon class="mr-1">mdi-arrow-left-bold-circle-outline</v-icon>
        back
      </v-btn>
      <span id="agent-monitor-header-title">{{$t('agentMonitor.title')}}</span>
      <div id="agent-monitor-header-bot-list">
        <v-menu bottom offset-y>
          <template v-slot:activator="{ on }">
            <div v-on="on" id="agent-monitor-header-active-bot">
              <span>{{ activeBot ? activeBot.name : '' }}</span>
              <v-icon color="#fff">mdi-chevron-down</v-icon>
            </div>
          </template>
          <div id="agent-monitor-header-bot-list-menu">
            <v-list>
              <v-list-tile
                  v-for="bot in botList"
                  :key="bot.code"
                  @click="onChangeBot(bot)"
                  :class="activeBot.code === bot.code ? 'active' : ''"
              >
                <v-list-tile-title>{{ bot.name }}</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </div>
        </v-menu>
      </div>
    </div>
    <div id="agent-monitor-body" v-if="botConfig['allowAgentMonitor']" class="fill-height" >
        
        <div class="agent-monitor-content" >
            <div class="filter-wrapper">
                <AgentMonitorFilterBox @onRefresh="onRefresh"></AgentMonitorFilterBox>
            <v-btn color="primary" @click="showDialog = true" style="float:right" >{{ $t('agentMonitor.exportExcel') }}</v-btn>
            </div>
            <div class="card">
            <div class="card-header">
                <span class="card-title">{{ $t('agentMonitor.statusMonitor') }}</span>
                <slot name="action"></slot>
            </div>
            <div class="card-content" v-if="rows && rows.length > 0">
                <div class="chat_view_loading" v-if="loadingDialog">
                    <div class="loading_overlay"></div>
                    <v-progress-circular indeterminate size="54" color="white"></v-progress-circular>
                </div>
            <TimelineChart v-else :rows="rows" :columns="columns"/>
            <v-pagination
                v-model="page"
                :length="pagesNumber"
                :total-visible="7"
                @input="getAgentStatusLog"
                circle
                class="custom-pagination"
                ></v-pagination>
            </div>
            <div class="card-content" v-else >
                No data
            </div>
            </div>
            <!-- <div class="card">
            <div class="card-header">
                <span class="card-title">Status monitor</span>
                <slot name="action"></slot>
            </div>
            <div class="card-content">
               <AgentStatus></AgentStatus>
            </div>
            </div> -->
        </div>
           
       
    </div>
  </div>
        
    </div>
     
  </template>
  
<script>
    import DatePickerOutline from "components/custom/DatePickerOutline";
    import StaffService from "@/services/staff.service";
    import TimelineChart from '@/components/charts/TimelineChart';
    import ActionTypes from "@/store/ActionTypes";
    import BotService from '@/services/bot.service'
    import ReportService from "@/services/report.service";
    import AgentMonitorFilterBox from './AgentMonitorFilterBox.vue';
    import _ from "lodash";
    import moment from 'moment';
    import {mapActions, mapState} from "vuex";
    export default {
        name: 'AgentMonitor',
        data() {
            return {
                loadingDialog: false,
                activeBot: {},
                botList: [],
                page: 1,
                pageSize: 30,
                fromDate: moment().format('YYYY-MM-DD'),
                toDate: moment().format('YYYY-MM-DD'),
                toDay: moment().format('YYYY-MM-DD'),
                minDate: moment('2024-06-11').format('YYYY-MM-DD'),
                showDialog: false,
                pagesNumber: null,
                columns:[
                    { type: "string", id: "agent" },
                    { type: "string", id: "status" },
                    { type: 'string', role: 'tooltip', p: { 'html': true } },
                    { type: "date", id: "Start" },
                    { type: "date", id: "End" },
                   
                ],
                rows: []
            }
        },
        components: {
            TimelineChart,
            AgentMonitorFilterBox,
            DatePickerOutline
        },
        computed: {
            ...mapState(['botStaffList', 'user']),
            ...mapState('agentMonitor', ['filter']),
            ...mapState('config', ['botConfig']),
            isValidTimeRangeFilter() {
                return moment.utc(this.toDate).diff(this.fromDate, 'days')  <= 30;
            },
            // activeBot() {
            // const botCode = this.$route.params.botCode;
            // console.log(botCode)
            // if (botCode) {
            //     let bot = _.find(this.botStaffList, o => o.bot_code === botCode);
            //     return bot ? {code: bot.bot_code, name: bot.bot_name} : {}
            // }
            // return {}
            // },
            // botList() {
            // return _.map(this.botStaffList, o => {
            //     return {name: o.bot_name, code: o.bot_code}
            // });
            // },
           
        },
        async mounted(){
            let has_permission = await this.hasPermission();
            let botCode = this.$route.params.botCode;
            if (botCode) {
                await BotService.getAndSetBotConfig(botCode);
            }
            if(has_permission && this.botConfig['allowAgentMonitor']){
                this.loadingDialog = true

                BotService.getAllBot().then(
                    result => {
                        this.botList = result.data;
                        let botCode = this.$route.params.botCode
                        if (botCode) {
                            let bot = _.find(this.botList, bot => bot.code === botCode)
                            if (bot) {
                                this.onChangeBot(bot)
                            } else {
                                this.loadingDialog = false
                                this.$router.push('/agent-monitor')
                            }
                        } else if (this.botList.length > 0) {
                            this.onChangeBot(this.botList[0])
                        } else {
                            this.loadingDialog = false
                        }
                    },
                ).catch(()=>{
                    this.$AppService.handleRequestError('can not get bot list')
                });
            }
            else {
                this.$router.push('/forbidden')
            }
         
        },
        methods: {
            ...mapActions('config', ['getBotConfig']),
            hasPermission(){
                return StaffService.checkStaffHasRole(this.$route.params.botCode, this.user.id, [10, 9, 5]);
            },
            transformData(data) {
                const results = data.agentStatusLogs.results;
                const supporters = data.supporters;
                
                // Helper function to find email by agent_id
                function findEmailById(id) {
                    const supporter = supporters.find(supporter => supporter.id === id);
                    return supporter ? supporter.email : null;
                }

                let transformedData = [];

                results.forEach(agent => {
                    const agentEmail = findEmailById(agent._id);
                    const logs = agent.logs;
                   
                    if (agentEmail) {
                        let startOfDay = new Date(moment(this.filter.date).startOf('day'));  // 00:00:00
                        let endOfDay = new Date(moment(this.filter.date).endOf('day'));
                        let currentTime = new Date(moment())
                        agent['total_ready'] = 0
                        agent['total_not_ready'] = 0
                        let appendData = []
                        for (let i = 0; i < logs.length; i++) {
                            const currentLog = logs[i];
                            const nextLog = logs[i + 1];

                            let startDate = new Date(currentLog.created_time);
                            let endDate = nextLog ? new Date(nextLog.created_time) : currentTime;
                            // if(i===0 ){
                          
                            //     // if(currentLog.isActive){
                            //     //     agent['total_not_ready'] += this.calculateTimeDifference(startOfDay,startDate) 
                                
                            //     // }else{
                            //     //     agent['total_ready'] += this.calculateTimeDifference(startOfDay,startDate) 
                            //     // }
                             
                            //     // appendData.push([
                            //     //     agentEmail,
                            //     //     !currentLog.isActive ? "ready" : "notReady",
                            //     //     startOfDay,
                            //     //     startDate
                            //     //     ]);
                            //     // }
                            //    startDate = startOfDay
                            // }
                            if (i===logs.length-1){
                                if(currentTime < endOfDay){
                                    endDate = currentTime
                                }
                                else{
                                    endDate = endOfDay
                                }
                            }
                            agent['total_ready'] += (currentLog.isActive ? this.calculateTimeDifference(startDate,endDate) : 0)
                            agent['total_not_ready'] += (currentLog.isActive ? 0 : this.calculateTimeDifference(startDate,endDate))
                            
                            // agent['total_ready'] = this.formatTime(agent['total_ready'])
                            // agent['total_not_ready'] = this.formatTime(agent['total_not_ready'])
                            
                            appendData.push([
                                agentEmail,
                                currentLog.isActive ? "ready" : "notReady",
                                startDate,
                                endDate
                            ]);
                        }
                        
                        agent['total_ready'] = this.formatTime(agent['total_ready'])
                        agent['total_not_ready'] = this.formatTime(agent['total_not_ready'])
                       
                        appendData.forEach(row =>{
                            let duration = this.formatTime(this.calculateTimeDifference(row[2], row[3]))
                            let fromDate = this.formatDate(row[2])
                            let endDate = this.formatDate(row[3])
                            let tooltipContent =  `
                                <div style="width:200px">
                                    <h4 class="my-2 mx-2">${this.$t('agentMonitor.detail')}</h4>
                                    <p class="my-2 mx-2">${this.$t('agentMonitor.status')}: ${this.$t('agentMonitor.'+row[1])}</p>
                                    <p class="my-2 mx-2">${this.$t('agentMonitor.period')}: ${fromDate} - ${endDate}</p>
                                    <p class="my-2 mx-2">${this.$t('agentMonitor.duration')}: ${duration}</p>
                                    <hr>
                                    <h4 class="my-2 mx-2">${this.$t('agentMonitor.summary')}</h4>
                                    <p class="my-2 mx-2">${this.$t('agentMonitor.totalReadyTime')}: ${agent['total_ready']}</p>
                                    <p class="my-2 mx-2">${this.$t('agentMonitor.totalNotReadyTime')}: ${agent['total_not_ready']}</p>
                                    </div>
                                `
                                row.splice(2, 0, tooltipContent);
                            
                        })
                        transformedData = [...transformedData,...appendData]
                    }
                });
                
                return transformedData;
            },
            handleFromDateChange() {
                if (!this.isValidTimeRangeFilter) {
                    const maxAllowedToDate = moment.utc(this.fromDate).add(30, 'days');
                    this.toDate = maxAllowedToDate.toISOString().substr(0, 10);

                }

            },
            handleToDateChange() {
                if (!this.isValidTimeRangeFilter ) {
                    const minAllowedFromDate = moment.utc(this.toDate).subtract(30, 'days');
                    this.fromDate = minAllowedFromDate.toISOString().substr(0, 10);

                }
            },

            async exportExcel() {
               
                let fromDate = new Date(moment(this.fromDate).startOf('day'));  // 00:00:00
                let toDate = new Date(moment(this.toDate).endOf('day'));
                ReportService.agentMonitorExcel(this.activeBot.code, fromDate, toDate )
                    .then((response) => {
                        const link = document.createElement('a');
                        const downloadLink = response.data.url;

                        link.href = downloadLink;
                        link.download = '';
                        link.style.display = 'none'; // Ẩn phần tử <a>
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link); // Sau khi tải xuống, loại bỏ phần tử <a>
                        this.$AppService.toastSuccess(this.$t("reportSuccess"))
                        this.showDialog = false
                        // this.is_lock_report = true
                    }).catch(()=> {
                        this.$AppService.toastError(this.$t("reportFailed"));
                        this.showDialog = false
                    });
            },
            onChangeBot(bot) {
                this.activeBot = bot
                    this.$store.commit(ActionTypes.BOT, bot)
                    if(this.$route.params.botCode != bot.code){
                        this.$router.push('/agent-monitor/' + bot.code)
                    }
                this.fromDate = this.toDate = moment(this.filter.date).format('YYYY-MM-DD')
                this.getAgentStatusLog()
                this.getBotConfig(this.$route.params.botCode)
            },
            async getAgentStatusLog(){
                this.loadingDialog = true
                let startOfDay = new Date(moment(this.filter.date).startOf('day'));  // 00:00:00
                let endOfDay = new Date(moment(this.filter.date).endOf('day'));
                await ReportService.getAgentStatusLog(this.activeBot.code, startOfDay, endOfDay, this.page, this.pageSize )
                    .then(result => {
                        let data = result.data;
                        this.rows = this.transformData(data)
                        let total =  data.agentStatusLogs.count ? data.agentStatusLogs.count[0].total : 0
                        this.pagesNumber = Math.floor(total / this.pageSize) + 1;
                        this.loadingDialog = false
                    }, () => {
                        this.$AppService.handleRequestError('can not get session info data')
                        this.loadingDialog = false
                    })
            },
            calculateTimeDifference(startDate, endDate) {
                // Chuyển đổi ngày thành milliseconds
                const startMillis = startDate.getTime();
                const endMillis = endDate.getTime();
                let differenceMillis = endMillis - startMillis;
                return differenceMillis;
            },
            formatTime(differenceMillis){
                const hours = Math.floor(differenceMillis / (1000 * 60 * 60));
                differenceMillis -= hours * (1000 * 60 * 60);
                
                const minutes = Math.floor(differenceMillis / (1000 * 60));
                differenceMillis -= minutes * (1000 * 60);
                
                const seconds = Math.floor(differenceMillis / 1000);
                const formattedTime = `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
                return formattedTime
            },
            formatDate(date){
                return moment(date).utcOffset('+0700').format("HH:mm:ss")
            },
            initBotStaffList() {
            if (this.botStaffList.length < 1) {
                this.$store.dispatch(this.$ActionTypes.GET_BOT_STAFF);
            }
            },
            
            onRefresh() {
                this.fromDate = this.toDate = moment(this.filter.date).format('YYYY-MM-DD')
               this.getAgentStatusLog()
            }
        },
    };
</script>
<style scoped lang="scss">
@import "components/style/agent-monitor";
.card {
  max-height: 400px;
  background-color: #EDEDF2;
  border: 1px solid #EDEDF2;
  display: flex;
  gap: 1px;
  border-radius: 5px;
  flex-direction: column;
  .card-header {
    padding-left: 10px;
    gap: 10px;
    display: flex;
    background-color: #F6F6FA;
    justify-content: space-between;
    align-items: center;
    height: 40px;
    border-radius: 5px 5px 0 0;
    .card-title {
      font-size: 14px;
      font-weight: bold;
      color: black;
    }
  }
  .card-content {
    position: relative;
    display: flex;
    background-color: white;
    flex: 1;
    flex-direction: column;
    align-items: center;
    padding: 20px;
    border-radius: 0 0 5px 5px;
  }
}
.filter-wrapper {
  display: flex;
  gap: 10px;

  .filter-input {
    height: 38px;
  }

  button {
    margin: 0 6px;
    height: 38px;
    border-radius: 5px;
  }
}
.google-visualization-tooltip {
  padding: 10px 10px 0 10px;
  font-size: 14px;
  width: 100px;
}
.google-visualization-tooltip ul {
  margin: 0;
  padding-left: 15px;
}
</style>